import { spaceCadet, ultraMarine } from '@cogneed/react-utils';
import { Box, styled } from '@mui/material';

export const StyledLoadingBox = styled(Box)({
  opacity: 0.8,
  width: '100%',
  height: 256,
  display: 'flex',
  justifyContent: 'center',
  '& .MuiCircularProgress-root': {
    color: ultraMarine[500],
  },
});
export const StyledEmptyBox = styled(Box)({
  padding: '0px 24px',
  '& .MuiTypography-root': {
    fontSize: 16,
    color: spaceCadet[700],
    fontWeight: 600,
    textTransform: 'none',
  },
});
